var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeolocationOutlineControl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#000000",
    strokeWidth: 2.25
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 2.5,
    x2: 10,
    y2: 0.625,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 19.375,
    x2: 10,
    y2: 17.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,3.25 C8.665,3.25 7.35994,3.64588 6.2499,4.38758 C5.13987,5.12928 4.27471,6.18349 3.76382,7.41689 C3.25292,8.6503 3.11925,10.0075 3.3797,11.3169 C3.64015,12.6262 4.28303,13.829 5.22703,14.773 C6.17104,15.717 7.37377,16.3599 8.6831,16.6203 C9.9925,16.8808 11.3497,16.7471 12.5831,16.2362 C13.8165,15.7253 14.8707,14.8601 15.6124,13.7501 C16.3541,12.6401 16.7499974,11.335 16.7499974,10 C16.7499974,8.2098 16.0388,6.4929 14.773,5.22703 C13.5071,3.96116 11.7902,3.25 10,3.25 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 10,
    x2: 19.375,
    y2: 10,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: 10,
    x2: 2.5,
    y2: 10,
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocationOutlineControl);
export default __webpack_public_path__ + "static/media/geolocation-outline-control.0341c8a6dd29aa7afab983617cfe5760.svg";
export { ForwardRef as ReactComponent };